export interface TreatmentPlanTemplateItemApiResource {
  treatment_id: string;
  treatment_name: string;
  instructions: string | null;
  sort_order: number;
}

export interface TreatmentPlanTemplateItem {
  treatmentId: string;
  treatmentName: string;
  instructions: string | null;
  sortOrder: number;
}

export interface TreatmentPlanTemplateExerciseApiResource {
  name: string;
  instructions: string | null;
  frequency: string | null;
  sort_order: number;
}

export interface TreatmentPlanTemplateExercise {
  name: string;
  instructions: string | null;
  frequency: string | null;
  sortOrder: number;
}

export interface TreatmentPlanTemplateApiResource {
  code: string;
  name_en: string;
  name_pl: string;
  items: TreatmentPlanTemplateItemApiResource[];
  exercises: TreatmentPlanTemplateExerciseApiResource[];
}

export interface TreatmentPlanTemplate {
  code: string;
  nameEn: string;
  namePl: string;
  items: TreatmentPlanTemplateItem[];
  exercises: TreatmentPlanTemplateExercise[];
}

export interface TreatmentPlanTemplatesApiResource {
  templates: TreatmentPlanTemplateApiResource[];
}

export interface TreatmentPlanTemplateItemDraft {
  treatmentId: string;
  instructions: string | null;
  sortOrder: number;
}

export interface TreatmentPlanTemplateExerciseDraft {
  name: string;
  instructions: string | null;
  frequency: string | null;
  sortOrder: number;
}

export interface TreatmentPlanTemplateDraft {
  code: string | null;
  nameEn: string;
  namePl: string;
  items: TreatmentPlanTemplateItemDraft[];
  exercises: TreatmentPlanTemplateExerciseDraft[];
}

function mapTreatmentPlanTemplateItem(
  resource: TreatmentPlanTemplateItemApiResource
): TreatmentPlanTemplateItem {
  return {
    treatmentId: resource.treatment_id,
    treatmentName: resource.treatment_name,
    instructions: resource.instructions,
    sortOrder: resource.sort_order,
  };
}

function mapTreatmentPlanTemplateExercise(
  resource: TreatmentPlanTemplateExerciseApiResource
): TreatmentPlanTemplateExercise {
  return {
    name: resource.name,
    instructions: resource.instructions,
    frequency: resource.frequency,
    sortOrder: resource.sort_order,
  };
}

function mapTreatmentPlanTemplate(
  resource: TreatmentPlanTemplateApiResource
): TreatmentPlanTemplate {
  return {
    code: resource.code,
    nameEn: resource.name_en,
    namePl: resource.name_pl,
    items: resource.items.map(mapTreatmentPlanTemplateItem),
    exercises: resource.exercises.map(mapTreatmentPlanTemplateExercise),
  };
}

export function mapApiResourceToTreatmentPlanTemplates(
  resource: TreatmentPlanTemplatesApiResource
): TreatmentPlanTemplate[] {
  return resource.templates.map(mapTreatmentPlanTemplate);
}

export function mapTreatmentPlanTemplateDrafts(
  drafts: TreatmentPlanTemplateDraft[]
): Record<string, unknown> {
  return {
    templates: drafts.map(function toApiTemplate(draft) {
      return {
        code: draft.code,
        name_en: draft.nameEn,
        name_pl: draft.namePl,
        items: draft.items.map(function toApiItem(item) {
          return {
            treatment_id: item.treatmentId,
            instructions: item.instructions,
            sort_order: item.sortOrder,
          };
        }),
        exercises: draft.exercises.map(function toApiExercise(exercise) {
          return {
            name: exercise.name,
            instructions: exercise.instructions,
            frequency: exercise.frequency,
            sort_order: exercise.sortOrder,
          };
        }),
      };
    }),
  };
}
